/**
 * Wrap table on mobile
 */
const wrapTable = () => {

    const tableEl = document.querySelector('.mobile-table table');

    if (tableEl) {
        const thEls = tableEl.querySelectorAll('thead th');
        const tdLabels = Array.from(thEls).map(el => el.innerText);

        tableEl.querySelectorAll('tbody tr').forEach(tr => {
            Array.from(tr.children).forEach(
                (td, ndx) => td.setAttribute('label', tdLabels[ndx])
            );
        });
    }
}

export { wrapTable };
